
export default function TrustHeroSection() {
  return (
    <section 
      className="relative h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(102, 51, 51, 0.7), rgba(102, 51, 51, 0.7)), url('https://public.readdy.ai/ai/img_res/5af2c0c52f058881b1993f907dbd4881.jpg')`
      }}
    >
      <div className="text-center text-white z-10 px-6">
        <h1 className="text-2xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold mb-6">
          "三真"承诺体系
        </h1>
        <p className="text-sm sm:text-base lg:text-xl xl:text-2xl mb-8 opacity-90">
          透明化体系 · 数据化标准 · 可视化体验
        </p>
        <div className="w-32 h-1 bg-[#cc9966] mx-auto mb-8"></div>
        <p className="text-xs sm:text-sm lg:text-lg xl:text-xl max-w-3xl mx-auto leading-relaxed">
          重构年份茶行业生态，让每一片茶叶都有迹可循，每一个年份都有据可查，每一次转化都有科学保障
        </p>
      </div>
    </section>
  );
}
